import axios from 'axios'
// import global from 'global'
import router from '@/router'

// 创建axios实例
const instance = axios.create({
  // baseURL: "https://api.pochanyun.com/api",
  // baseURL: "https://live.pochanyun.net/api",
   baseURL: "/api",
  timeout: 60000
})

// request-interceptor
instance.interceptors.request.use(
  config => {
	 
    let token = sessionStorage.getItem('ms_token')
    if (config.url.includes('/login')) {
      // config.headers.Authorization = "Bearer cGNfY291cnRfbGl2ZTpwY19jb3VydF9saXZl"
	  config.headers = {
	    'Content-Type': 'application/json',
	  }
    } else if (config.url.includes('/part-file')) {
      config.headers = {
        'Content-Type': 'multipart/form-data',
        'Authorization': token ? config.headers.Authorization = 'Bearer ' + token : ''
      }
    } else {
      config.headers = {
        'Content-Type': 'application/json; charset=UTF-8',
        'Authorization': token ? config.headers.Authorization = 'Bearer ' + token : ''
      }
    }
    return config
  },
  error => {
    Promise.reject(error)
  }
)

// response-interceptor
instance.interceptors.response.use(
  response => {
    if (response.status === 204) {
      response.data = null
    }
    return response.data
  },
  error => {
    const err = error.response
    if (!err) {
      return
    }
    if (err.status === 401) {
      // do something before 401 reject
      // router.push('/401')
      // message.error('您没有登录或登录已超时')
      window.sessionStorage.clear()
      router.push('/login')
    }
    if (err.status === 406) {
      console.error('您没有权限进行此操作')
      // return Promise.reject(err.data)
    }
    if (err.status === 400 && err.data === 'xss') {
      console.error('输入字符串存在异常字符，请检查确认')
      // return Promise.reject(err.data)
    }
    if (err.config.url == null || err.status !== 401) {
      // return Promise.reject(err.data)
    }

    return Promise.reject(err)
  }
)
export default instance
